var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-header-actions"},[_vm._t("action")],2)]),_c('b-card-body',{staticClass:"p-0"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_vm._t("body")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }